import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch } from "react-redux";
import { AdminCreateInspirationsThunk } from "../../apps/inspirationSlice";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { inspirationSchema } from "../../validations";



const AddInspirations = ({ onHide }) => {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);


    const formik = useFormik({
        initialValues: {
            title: "",
            prompt: "",
            image: null
        },
        validationSchema: inspirationSchema,
        onSubmit: async (values, { resetForm }) => {

            const formData = new FormData();
            formData.append("title", values.title);
            formData.append("prompt", values.prompt);
            formData.append("image", values.image);

            const response = await dispatch(AdminCreateInspirationsThunk(formData));
            if (response?.payload?.success) {
                toast.success('Inspiration created successfully.');
                formik.resetForm();
                if (fileInputRef.current) fileInputRef.current.value = "";
                onHide();
            } else {
                toast.error('Some problem exist, Please try again')
            }
        }
    });

    return (
        <div className="container mt-5">
            <form onSubmit={formik.handleSubmit}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                            <div className="card shadow-sm p-4 mb-4 w-100">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">📌 Title</label>
                                        <input
                                            type="text"
                                            name="title"
                                            className="form-control"
                                            placeholder="Enter title"
                                            value={formik.values.title}
                                            onChange={formik.handleChange}
                                        />
                                            {formik.touched.title && formik.errors.title ? (
                                        <span style={{ color: "red" }}>
                                                <div>{formik.errors.title}</div>
                                        </span>
                                            ) : null}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">💡 Prompt</label>
                                        <textarea
                                            rows={6}
                                            name="prompt"
                                            className="form-control"
                                            placeholder="Enter prompt"
                                            value={formik.values.prompt}
                                            onChange={formik.handleChange}
                                        />
                                        {formik.touched.prompt && formik.errors.prompt ? (
                                            <span style={{ color: "red" }}>
                                                <div>{formik.errors.prompt}</div>
                                            </span>
                                        ) : null}
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label fw-bold">🖼️ Image</label>
                                        <input
                                            type="file"
                                            accept="image/png, image/jpeg"
                                            ref={fileInputRef}
                                            onChange={(event) => formik.setFieldValue("image", event.currentTarget.files[0])}
                                        />

                                            {formik.touched.image && formik.errors.image ? (
                                        <span style={{ color: "red" }}>
                                                <div>{formik.errors.image}</div>
                                        </span>
                                            ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="d-flex justify-content-between w-100">
                                <button type="submit" className="btn btn-primary">✅ Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddInspirations;
